export const CustomEventTypes = {
  RESPONSE_HOVERED: 'responseHovered',
  RESPONSE_UNHOVERED: 'responseUnhovered'
}
